import { gql } from "@apollo/client";

export const GetPolicy = gql`
  query GetPolicy($id: String!) {
    policyOne(id: $id) {
      name
      isPdf
      fileUrl
      data
      documentId
    }
  }
`;

export const GetPolicies = gql`
  query GetPolicies {
    policyMany {
      id
      name
    }
  }
`;

export const GetPolicyPage = gql`
  query GetPolicyPage($pagination: PaginationInput!) {
    policyPage(pagination: $pagination) {
      items {
        id
        name
        createdDate
        fileUrl
        data
        isActive
      }
      totalRows
    }
  }
`;

export const GetEditorLink = gql`
  query GetEditorLink($id: String!) {
    getEditorLink(id: $id)
  }
`;
